import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Notification from '../../components/Notification';
import ToastNotification from '../../components/Notification/toasNotification/ToasNotification';

export const TOAST_NOTIFICATION = 'TOAST_NOTIFICATION'

const NOTIFICATION_COMPONENTS = {
  ['DEFAULT']: Notification,
  [TOAST_NOTIFICATION]: ToastNotification,
};

class NotificationConductor extends PureComponent {
  shouldComponentUpdate(nextProps) {
    return JSON.stringify(nextProps) !== JSON.stringify(this.props);
  }

  render() {
    const { typeNotification,  ...notificationProps } = this.props;

    if (!notificationProps.show) return null

    const NotificationComponent = NOTIFICATION_COMPONENTS[typeNotification] || NOTIFICATION_COMPONENTS['DEFAULT'];
    return <NotificationComponent {...notificationProps} />;
  }
}

export default connect(
  state => state.notification.notificationProps
)(NotificationConductor);


// WEBPACK FOOTER //
// ./src/containers/Notification/index.jsx